import React, { useMemo } from "react";

import { useSchools } from "~/hooks/useSchools";

import type { POICategory, POIGroup, SchoolGroup } from "../types";
import { categories } from "../constants";

import { usePois } from "./usePois";

type Options = {
  lat?: number;
  lng?: number;
  category?: POICategory;
  radius?: number;
};

export const useMarkers = ({ lat, lng, category, radius = 2000 }: Options) => {
  const { isLoading: isPoisLoading, data: poisData } = usePois({
    lat,
    lng,
    include:
      category && category !== "schools"
        ? (categories[category].pois as POIGroup)
        : undefined,
    radius,
  });

  const { isLoading: isSchoolsLoading, data: schoolsData } = useSchools({
    lat,
    lng,
    include:
      category && category === "schools"
        ? (categories[category].pois as SchoolGroup)
        : undefined,
    radius,
    includeCatchments: true,
  });

  const markers = useMemo(
    () => [].concat(...Object.values(poisData || schoolsData || [])),
    [poisData, schoolsData]
  );

  return {
    isLoading: isPoisLoading || isSchoolsLoading,
    data: markers,
  };
};
